/**
 * RepStatusBar component.
 * Displays a status bar for reps, showing their name and lead mode, and allows clearing the lead.
 *
 * @component
 * @returns {JSX.Element|null} The rendered rep status bar or null if not a rep.
 */
// External packages
import { useTranslation } from "react-i18next";

// Internal shared modules
import { useAuthContext } from "../../../context/AuthContext";
import { clearLead } from "../../../api/register/clearLeadApi";

// Styles
import "./RepStatusBar.css";

export default function RepStatusBar() {
  const { t } = useTranslation();
  const { isRep, repUserName, leadData, clearLeadLocal } = useAuthContext();
  if (!isRep) return null;

  const name = repUserName || t("shared.rep_status_bar.default_name");
  const prefix = t("shared.rep_status_bar.greeting_prefix");
  const suffix = t("shared.rep_status_bar.greeting_suffix");
  const mode = t("shared.rep_status_bar.lead_mode");
  const btnTxt = t("shared.rep_status_bar.clear_lead_button");

  // Handle clearing the lead
  async function handleClear() {
    const res = await clearLead();
    if (res?.status === 1) clearLeadLocal();
  }

  return (
    <div className="rep-status-bar" data-testid="rep-status-bar">
      <div className="rep-status-bar__content">
        <span className="rep-status-bar__greeting" data-testid="rep-greeting">
          {`${prefix} ${name}, ${suffix}`}
        </span>
        {leadData && Object.keys(leadData).length > 0 && (
          <>
            <span className="rep-status-bar__greeting" data-testid="rep-lead-mode">
              {mode}
            </span>
            <button 
              className="rep-status-bar__button" 
              onClick={handleClear}
              data-testid="rep-clear-lead-button"
            >
              {btnTxt}
            </button>
          </>
        )}
      </div>
    </div>
  );
}
